import { AnimatePresence, motion } from 'framer-motion';

export const FadeReplace = ({
  firstElement,
  secondElement,
  showFirst,
}: {
  firstElement: any;
  secondElement: any;
  showFirst: boolean;
}) => {
  return (
    <AnimatePresence>
      {showFirst ? (
        <motion.div
          key="firstElement"
          initial={{ opacity: 1 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
        >
          {firstElement}
        </motion.div>
      ) : (
        <motion.div
          key="secondElement"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2, delay: 0.2 }}
        >
          {secondElement}
        </motion.div>
      )}
    </AnimatePresence>
  );
};
